module.exports = __webpack_public_path__ + "media/images/More-blue-c510fbbe8678ddf36b9c2180ffbd7934.svg";